import { useRouter } from 'next/router';
import EFPicture from 'elem/compCommon/EFPicture';
import { postcodeQueryObj } from './postcodeQueryText';
import css from './index.module.scss';
import QuoteWin from '@elem/compCommon/ProductConstructor/BriefGuide/Info/QuoteWin';
import { useState } from 'react';
import { getCheckZipCode } from '@elem/Service/delta-pro-ultra';

const ActiveIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
        <path d="M7.5 14C11.0899 14 14 11.0899 14 7.5C14 3.91015 11.0899 1 7.5 1C3.91015 1 1 3.91015 1 7.5C1 11.0899 3.91015 14 7.5 14Z" stroke="#30BF00" />
        <path
            d="M7.26494 11C7.12045 11 6.97595 10.9372 6.86674 10.8136L4.16507 7.75676C3.94498 7.50757 3.94498 7.1043 4.16507 6.85512C4.38517 6.60593 4.74136 6.60593 4.96146 6.85512L7.26494 9.46112L11.0385 5.18689C11.2586 4.9377 11.6148 4.9377 11.8349 5.18689C12.055 5.43608 12.055 5.83934 11.8349 6.08853L7.66145 10.8136C7.55224 10.9391 7.40775 11 7.26494 11Z"
            fill="#30BF00"
        />
    </svg>
);

const InActiveIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
        <g clipPath="url(#clip0_14654_6477)">
            <path
                d="M6.14966 3L6.46258 7.78185H7.53742L7.85034 3H6.14966ZM6.9932 8.94459C6.72109 8.94459 6.4898 9.0285 6.29932 9.22431C6.09524 9.40613 6 9.64389 6 9.9376C6 10.2173 6.09524 10.4551 6.29932 10.6509C6.4898 10.8467 6.72109 10.9446 6.9932 10.9446C7.26531 10.9446 7.5102 10.8467 7.71429 10.6649C7.90476 10.4691 8 10.2313 8 9.9376C8 9.64389 7.90476 9.40613 7.71429 9.22431C7.52381 9.0285 7.27891 8.94459 6.9932 8.94459Z"
                fill="#F8200C"
            />
            <path
                d="M7 13.5C10.5899 13.5 13.5 10.5899 13.5 7C13.5 3.41015 10.5899 0.5 7 0.5C3.41015 0.5 0.5 3.41015 0.5 7C0.5 10.5899 3.41015 13.5 7 13.5Z"
                stroke="#F8200C"
            />
        </g>
        <defs>
            <clipPath id="clip0_14654_6477">
                <rect width="14" height="14" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

export default function PostcodeQueryPopUp({ callback }: any) {
    const [inputVal, setInputVal] = useState('');
    const { locale = 'us' } = useRouter();
    const postcodeQueryText = postcodeQueryObj[locale as any] || postcodeQueryObj['us'];
    const [isCanInstall, setIsCanInstall] = useState(2);
    const [openQuoteFlag, setOpenQuoteFlag] = useState(false);

    const [isError, setIsError] = useState(false);

    const handleSubmit = async () => {
        if (!inputVal) return;

        try {
            setIsCanInstall(2);
            const res = await getCheckZipCode(locale, inputVal);
            if (res?.code !== '0') {
                setIsError(false);
                console.error(res?.message);
            } else {
                setIsError(true);
                setIsCanInstall(res?.data ? 1 : 0);
            }
        } catch (e) {
            console.error(e);
        }
    };
    const handleInputChange = (v: any) => {
        setInputVal(v.target.value);
    };
    const quoteCallback = (type: string) => {
        if (type === 'close') {
            setOpenQuoteFlag(false);
        }
    };
    return (
        <div
            className={`installation-tips ${css['installation-tips']} ${isError ? 'installation-tips-error' : ''} GtmModuleData-section`}
            data-section-id={'dpu-PostcodeQueryPopUp'}
            data-section-title={'dpu-PostcodeQueryPopUp'}
        >
            <div className="tips-box">
                <span className="header-close" onClick={callback}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <g opacity="0.4">
                            <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M12 2.7998C14.5403 2.7998 16.8403 3.82969 18.5052 5.49462C20.1702 7.15955 21.2001 9.45954 21.2001 11.9998C21.2001 14.5401 20.1702 16.8401 18.5052 18.505C16.8403 20.1699 14.5403 21.1998 12 21.1998C9.45978 21.1998 7.15979 20.1699 5.49486 18.505C3.82993 16.8401 2.80005 14.5401 2.80005 11.9998C2.80005 9.45954 3.82993 7.15955 5.49486 5.49462C7.15979 3.82969 9.45978 2.7998 12 2.7998Z"
                                stroke="white"
                                stroke-width="1.6"
                            />
                            <path d="M8.5 8.5L15.5 15.5M15.5 8.5L8.5 15.5" stroke="white" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
                        </g>
                    </svg>
                </span>
                <div className="tips-content">
                    <p className="tips-content-title">{postcodeQueryText.title}</p>
                    <div className={`control ${isCanInstall === 0 && 'notAvailable'}`}>
                        <input type="text" className="input" value={inputVal} onChange={handleInputChange} placeholder="Zip Code" />
                        <button className="subscribe" onClick={handleSubmit}>
                            Search
                        </button>
                    </div>
                    {isCanInstall === 2 && <p className="tips-reminder">Please enter a valid U.S. ZIP code (e.g., 12345).</p>}
                    {isCanInstall === 2 && (
                        <div className="tips-content-img">
                            <EFPicture src={'https://websiteoss.ecoflow.com/upload/image/1736306151675/Frame1612706940-P.png'} alt="" />
                        </div>
                    )}
                    {isCanInstall === 1 && (
                        <div className="tips-content-available">
                            <ActiveIcon />
                            &nbsp;
                            {postcodeQueryText.query_available}
                        </div>
                    )}
                    {isCanInstall === 0 && (
                        <div className="tips-content-notAvailable">
                            <InActiveIcon />
                            &nbsp;{postcodeQueryText.query_notAvailable}
                        </div>
                    )}
                    {(isCanInstall === 1 || isCanInstall === 0) && (
                        <div
                            className="tips-content-quote"
                            onClick={() => {
                                setOpenQuoteFlag(true);
                            }}
                        >
                            Get a Free Quote
                        </div>
                    )}
                </div>
            </div>
            {locale === 'us' && openQuoteFlag && <QuoteWin callback={quoteCallback} />}
            <style global jsx>
                {`
                    .ecoflow-frame-header {
                        z-index: 100 !important;
                    }
                `}
            </style>
        </div>
    );
}
